import React from "react";
import { ViewContainerFabric } from "@msidentity/SISU/components/view-container/fabric/view-container-fabric";
import { FlowId, ViewId } from "@msidentity/SISU/constants/routing-constants";
import { useDocumentTitle } from "@msidentity/SISU/hooks";
import { useActivateView } from "@msidentity/SISU/hooks/use-activate-view";
import { commonBindingsFabric } from "@msidentity/SISU/utilities/formatted-text-with-bindings";
import { usernameRecoveryGenericStringsFabric as genericStrings } from "../../../fabric/username-recovery-strings-fabric";
import { usePhoneSpeedbump } from "../hooks/use-phone-speedbump";

const titleId = "UsernameRecoveryTitle";
const descriptionId = "usernameRecoveryEnterCodeDescription";

/**
 * Phone Speedbump View Component for Username Recovery Flow
 * @returns instance of the view
 */
export const PhoneSpeedbumpViewFabric: React.FC = function PhoneSpeedbumpViewFabric() {
  const { onSubmitHandler, onBackHandler, description, title } = usePhoneSpeedbump();

  const { strong } = commonBindingsFabric;

  useActivateView(ViewId.UsernameRecoveryPhoneSpeedbump, FlowId.UsernameRecovery, {
    showIdentityBanner: false,
  });
  useDocumentTitle(title);

  return (
    <ViewContainerFabric
      applyAriaLive
      title={{
        titleId,
        title,
      }}
      description={{
        descriptionId,
        description,
        embeddedBindings: { username: strong },
      }}
      primaryButton={{
        label: genericStrings.next,
        onClick: onSubmitHandler,
        hasFocus: true,
      }}
      secondaryButton={{
        label: genericStrings.back,
        onClick: onBackHandler,
      }}
    />
  );
};
